// test1119
(1119 && 0);
